
 /* jQuery Pre loader */
$(window).load(function(){
    $('.preloader').fadeOut(1000);  
});

/* Mobile Navigation */
// $(window).scroll(function() {
//     if ($(".navbar").offset().top > 100) {
//         $(".sticky-top").addClass("top-nav-collapse");
//     } else {
//         $(".sticky-top").removeClass("top-nav-collapse");
//     }
// });

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}

/* HTML document is loaded. DOM is ready. */
$(document).ready(function() {

  /* Hide mobile menu after clicking on a link */
    $('.navbar-collapse a').click(function(){
        $(".navbar-collapse").collapse('hide');
    });


 /* Parallax section */
  function initParallax() {
    $('#home').parallax("100%", 0.1);
    $('#about').parallax("100%", 0.3);
    $('#detail').parallax("100%", 0.2);
    $('#video').parallax("100%", 0.3);
    $('#joblisting').parallax("100%", 0.1);
    $('#clients').parallax("100%", 0.2);
    $('#register').parallax("100%", 0.1);
    $('#history').parallax("100%", 0.3);
    $('#vision').parallax("100%", 0.3);
    $('#faq').parallax("100%", 0.3);
    $('#contact').parallax("100%", 0.2);
    $('#deployment').parallax("100%", 0.2);
    $('#contact-details').parallax("100%", 0.2);
    $('#pos-list').parallax("100%", 0.2);
  }
  initParallax();


  /* Owl Carousel */
  $(document).ready(function() {
    $("#owl-director").owlCarousel({
      autoPlay: 6000,
      items : 4,
      itemsDesktop : [1199,2],
      itemsDesktopSmall : [979,1],
      itemsTablet: [768,1],
      itemsTabletSmall: [985,2],
      itemsMobile : [479,1],
    });
  });


  /* Back top */
    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
        $('.go-top').fadeIn(200);
        } else {
          $('.go-top').fadeOut(200);
        }
        });   
        // Animate the scroll to top
      $('.go-top').click(function(event) {
        event.preventDefault();
      $('html, body').animate({scrollTop: 0}, 300);
      })


  /* wow */
  new WOW({ mobile: false }).init();

  });

  $('img').mousedown(function (e) {
    if(e.button == 2) { // right click
      return false; // do nothing!
    }
  });

  //***** Maintenance Mode *****//

  // const undermaintenanceModal = bootstrap.Modal.getOrCreateInstance('#um-modal');
  
  // window.addEventListener('DOMContentLoaded', () => {
  //   undermaintenanceModal.show();
  // });


  // Advertisement Modal
  const myModal = bootstrap.Modal.getOrCreateInstance('#popup-modal');
  
  window.addEventListener('DOMContentLoaded', () => {
    myModal.show();
  });